import React from 'react';
import { TabHeaderTemplate } from 'themes/components';

const TabHeader = (props) => {
    return <TabHeaderTemplate {...props} />
}

export default TabHeader;